$(function() {
    function fadeIn (margin) {
        $('.js-fadeIn').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if(scroll > elemPos - windowHeight + margin) {
                $(this).addClass('js-scrollIn');
            };
        });
    }
    $(window).on('scroll load touchmove', function(){
        if (window.matchMedia('(max-width: 879px)').matches) {
            //スマホ処理
            fadeIn(-50);
        } else if (window.matchMedia('(min-width: 880px)').matches) {
            //PC処理
            fadeIn(100);
        }
    });
});

$(function() {
    $('.js-slick').slick();
});